export const invoicesIva = {
	title: "Facturas Fiscales",
	period: "Período",
	downloadXML: "Descarga del XML",
	downloadJSON: "Descarga del JSON",
	descriptionForeign:
		"Este informe muestra las Facturas Fiscales y Notas de Crédito emitidas, permitiendo filtrar por período, perfil fiscal, empleado, tipo de factura (Factura Fiscal y Nota de Crédito) y tipo de elemento (Recarga o Producto).",
	modelLabel: {
		nfce: "NFC-e",
		nfse: "NFS-e",
		sat: "SAT",
		ivaVendus: "IVA - Vendus",
		ivaFactura: "IVA - Factura",
	},
	sheet: {
		title: "Facturas Fiscales",
		filename: "facturas_fiscales",
		columns: {
			issuedAt: "Emitida en",
			mode: "Modo de emisión",
			fiscalProfile: "Perfil fiscal",
			isCanceled: "Cancelada",
			eventDate: "Fecha del evento",
			serie: "Serie factura",
			number: "N° factura",
			transaction: "Transacción",
			recharge: "Recarga",
			employee: "Empleado",
			value: "Valor factura",
			imgUrl: "URL Imagen",
			pdfUrl: "URL PDF",
			xml: "XML",
			json: "JSON",
		},
	},
	columns: {
		issuedAt: "Emitida en",
		mode: "Modo de emisión",
		fiscalProfile: "Perfil fiscal",
		isCanceled: "Cancelada",
		type: "Tipo",
		eventDate: "Fecha del evento",
		serie: "Serie factura",
		number: "N° factura",
		value: "Valor factura",
		transaction: "Transacción",
		recharge: "Recarga",
		employee: "Empleado",
		fiscalMode: "Modo fiscal",
		expirationDate: "Fecha de expiración",
		errorMsg: "Error",
		status: {
			label: "Estado",
			pending: "Pendiente de creación",
			waiting: "Pendiente de emisión",
		},
		tooltips: {
			nc: "Nota de Crédito / Factura Cancelada",
			ft: "Factura / Facturas Fiscales",
		},
		actions: {
			title: "Acciones",
			pdf: "PDF",
			image: "Imagen",
			xml: "XML",
			cancelledXml: "XML de cancelación",
			json: "JSON",
			cancelledJson: "JSON de cancelación",
			cancel: {
				okText: "Sí, cancelar factura fiscal",
				title: "¿Está seguro que desea cancelar la factura fiscal?",
			},
			cancelUnnavailable: {
				okText: "Ok",
				title: "Facturas emitidas hace más de 30 minutos no pueden ser canceladas",
			},
		},
	},
	missing: {
		title: "Facturas Faltantes",
		titleForeign: "Facturas Pendientes",
		period: "Período",
		fiscalProfile: "Perfil fiscal",
		fiscalProfileLabel: "Filtrar por perfil fiscal",
		employeeLabel: "Filtrar por empleado",
		invoiceTypeLabel: "Filtrar tipo de documento",
		documentId: "Identificador",
		pendingAutoissuanceOrders: "Total bruto pendiente",
		zigSystemEmployee: "ZIG (sistema)",
		creditInvoiceLabel: "Notas de Crédito",
		itemTypeLabel: "Filtrar tipo de elemento",
		recharges: "Recargas",
		products: "Productos",
		invoiceLabel: "Facturas Fiscales",
		selectFiscalProfile: "Seleccione un perfil fiscal",
		download: "Descarga del XML",
		descriptionForeign:
			"Este informe muestra todas las Facturas pendientes, es decir, aquellas que llegaron al sistema, pero no fueron emitidas por algún motivo. Permite visualizar el mensaje de error asociado a cada Factura Pendiente.",
		descriptionForeignMEX:
			"Este informe muestra todas las Facturas pendientes, es decir, 1) aquellas que fueron recibidas por el sistema pero no fueron emitidas por algún motivo y 2) aquellas para las cuales se creó una orden de autofacturación y están esperando que el cliente emita. Permite visualizar el mensaje de error asociado a cada Factura pendiente.",
		columns: {
			serie: "Serie",
			number: "Número",
			employee: "Empleado",
			date: "Fecha",
			actions: "Acciones",
		},
	},
	downloadBackupModal: {
		title: "Descarga de archivos XML",
		placeholder: "Seleccione",
		error: "Error: {{error}}",
		empty: "Ningún respaldo disponible",
		content:
			"Para realizar la descarga de esta cantidad de archivos es necesario descargar el mes completo.",
		selectMonth: "Seleccione abajo el mes de referencia para descarga.",
	},
	filters: {
		zigSystemEmployee: "ZIG (sistema)",
		fiscalProfileLabel: "Filtrar por Perfil Fiscal",
		employeeLabel: "Filtrar por Empleado",
		invoiceType: "Filtrar por tipo de Factura",
		invoiceItemType: "Filtrar por tipo de elemento",
		invoiceItemTypeProduct: "Productos",
		invoiceItemTypeRecharge: "Recargas",
		invoiceTypeAll: "Todas las Facturas",
		invoiceTypeWithCreditInvoice: "Facturas con Notas de Crédito",
		invoiceTypeWithoutCreditInvoice: "Facturas sin Notas de Crédito",
	},
};
